<template>
  <div class="page-401">
    <div class="content">
      <img :src="img401" class="pic" alt="404" />

      <div class="des">
        <div class="message-title">
          未授权，您的访问被拒绝！
        </div>
        <div class="message-info">
          页面无权访问，<span class="timer">{{ timer }}</span
          >秒后跳转到登录页面
        </div>
        <div class="btns">
          <el-button size="large" type="primary" @click="login">
            立即登录
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import img401 from '@/assets/401_images/401.png'
export default {
  data() {
    return {
      img401,
      timer: 3,
      interval: null
    }
  },
  mounted() {
    document.getElementById('page-preloading').style.display = 'none'
    this.interval = window.setInterval(() => {
      if (this.timer > 0) {
        --this.timer
      }
      if (this.timer === 0) {
        this.login()
      }
    }, 1000)
  },
  beforeDestroy: function() {
    window.clearInterval(this.interval)
  },
  methods: {
    login() {
      this.$router.push('/login')
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
.page-401 {
  @include adaptation(
    (
      --btn-padding: 6px 20px,
      --display-img-width: 655px,
      --display-img-height: 447px
    )
  );
  --content-top: calc((100vh - var(--display-img-height)) / 5 * 2);
  background-color: var(--base-background-color-dark);
  height: 100vh;

  .content {
    top: var(--content-top);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;

    .pic {
      width: var(--display-img-width);
      height: var(--display-img-height);
    }

    .des {
      position: absolute;
      bottom: 0;
      .message-title {
        text-align: center;
        font-size: var(--base-font-size-large);
        color: var(--base-color-text-primary);
        line-height: var(--base-size-24);
        margin-bottom: var(--base-size-8);
      }

      .message-info {
        text-align: center;
        font-size: var(--base-font-size);
        color: var(--base-color-text-regular);
        line-height: var(--base-size-16);
        margin-bottom: var(--base-size-32);
      }

      .btns {
        display: flex;
        justify-content: center;

        .el-button {
          font-size: var(--base-font-size-medium);
          height: var(--base-size-32);
          padding: var(--btn-padding);
        }
      }
    }
  }
}
</style>
